import { MenuNavigationDropdown } from "./MenuNavigationDropdown";
import styles from "./styles.module.scss";

export const Menu = () => {
  return (
    <div className={styles.root}>
      <MenuNavigationDropdown />
    </div>
  );
};
